import useJ1AuthFetch from '@jupiterone/jupiter-web-toolkit/src/api/fetch/useJ1AuthFetch';
import { useAccounts } from '@jupiterone/jupiter-web-toolkit/src/api/fetch/useAccounts';
import { useUser } from '../api/fetch/useUser';
import { IAccount } from '../types';
import urls from '../urls';

const useAccountClient = () => {
  const { authFetch } = useJ1AuthFetch();
  const { account } = useAccounts();
  const { user } = useUser();

  async function createAccount(
    id: string,
    name: string,
    email?: string
  ): Promise<Response> {
    const accountType = 'FREE';
    return authFetch(urls.accounts, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        owner: email || user?.profile.email,
        name,
        id,
        type: accountType,
      }),
    });
  }

  async function patchAccount(
    updates: Partial<Pick<IAccount, 'name' | 'owner' | 'deletionDate'>>
  ): Promise<IAccount> {
    if (!account?.id) throw new Error('401: No account set');
    const response = await authFetch(`${urls.accounts}/${account.id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...updates,
      }),
    });

    return await response.json();
  }

  async function updateAccountLogo(logoUrl: string): Promise<Response> {
    if (!account?.id) throw new Error('401: No account set');
    const response = await authFetch(
      `${urls.accounts}/${account.id}/set-logo-url`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          logoUrl,
        }),
      }
    );
    return await response.json();
  }

  return {
    createAccount,
    patchAccount,
    updateAccountLogo,
  };
};

export default useAccountClient;
